import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { ResultSignageIf, SignageIf, SignageInfo } from '../interfaces/SignageIf'
import { useAuth } from './useAuth'
import { useApiUrl } from './useApiUrl'

interface C701SignageGetProps {
  execSignageGet: (deviceId: string) => Promise<ResultSignageIf>
  loading: loadStatus
}
// C701 サイネージ一覧取得API呼出
export const useC701SignageGet = (): C701SignageGetProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()
  const { buildDeviceUrl } = useApiUrl()
  const execSignageGet = async (deviceId: string) => {
    try {
      setLoading(loadStatus.LOADING)
      const jwt = await auth.getJwt()
      if (jwt === '') {
        setLoading(loadStatus.LOADED)
        //return { success: false, message: errorMsg.SESSION_ERROR }
      }
      // ヘッダ作成
      const header = Object.assign(axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })
      // console.log(header);

      const response = await axios.get(
        buildDeviceUrl(deviceId, apiUrl.signagesPath),
        {
          headers: header,
          validateStatus: () => true,
        },
      )

      if (response.status === apiStatus.SUCCESS) {
        if (response.data !== '' && response.data.signageList) {
          const infos: SignageIf[] = response.data.signageList.map((signage: SignageIf) => {
            return {
              ...signage,
              storage_path: String(signage.storage_path),
            }
          })
          // console.log(infos);
          setLoading(loadStatus.LOADED)
          return {
            success: true,
            info: { signageList: infos, orderby: response.data.orderby },
          }
        }
        const infos: SignageInfo = { signageList: [], orderby: 'asc' }
        setLoading(loadStatus.LOADED)
        return { success: true, info: infos }
      }
      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      // console.log(error);
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execSignageGet, loading }
}
